import React from 'react';
import './MovingBorderButton.css';

/** Call sites historically passed ms (e.g. 2500). Accept both ms and seconds. */
function toSeconds(duration: number): number {
  return duration > 100 ? duration / 1000 : duration;
}

interface MovingBorderButtonProps {
  children: React.ReactNode;
  borderRadius?: string;
  /** Time for one full loop. Accepts seconds (3) or milliseconds (3000). */
  duration?: number;
  glowColor?: string;
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
}

const MovingBorderButton: React.FC<MovingBorderButtonProps> = ({
  children,
  borderRadius = '0.6rem',
  duration = 3,
  glowColor = 'rgba(245, 158, 11, 0.9)',
  className = '',
  onClick,
  type = 'button',
}) => {
  const style = {
    borderRadius,
    '--mbb-glow': glowColor,
    '--mbb-duration': `${toSeconds(duration)}s`,
  } as React.CSSProperties;

  return (
    <button type={type} className={`mbb-container ${className}`} style={style} onClick={onClick}>
      <span className="mbb-content" style={{ borderRadius }}>
        {children}
      </span>
    </button>
  );
};

export interface MovingBorderBoxProps {
  children: React.ReactNode;
  borderRadius?: string;
  duration?: number;
  glowColor?: string;
  className?: string;
}

export const MovingBorderBox: React.FC<MovingBorderBoxProps> = ({
  children,
  borderRadius = '14px',
  duration = 5,
  glowColor = 'rgba(245, 158, 11, 0.8)',
  className = '',
}) => {
  const style = {
    borderRadius,
    '--mbb-glow': glowColor,
    '--mbb-duration': `${toSeconds(duration)}s`,
  } as React.CSSProperties;

  return (
    <div className={`mbb-container mbb-box ${className}`} style={style}>
      <div className="mbb-box-content" style={{ borderRadius }}>
        {children}
      </div>
    </div>
  );
};

export default MovingBorderButton;
